module.exports = __webpack_public_path__ + "static/media/logo-xd.c0c96993.svg";